/**
 * Scroll direction enum
 */

export enum ScrollDirections {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  FULL_TOP = 'FULL_TOP',
  FULL_BOTTOM = 'FULL_BOTTOM',
  FULL_LEFT = 'FULL_LEFT',
  FULL_RIGHT = 'FULL_RIGHT',
}
